import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Secretariats() {
  return (
    <ImageCollectionPage 
      title="Secretariats" 
      path="/secretariats" 
      collection="secretariats" 
    />
  );
}
